<template>
  <div>
    <div class="demand">
      <h2>{{ $t('message.index_title') }}</h2>
      <div class="container">
        <div class="row">
          <div class="demandbox">
            <div class="dbox1 col-xl-6 col-md-6">
              <router-link to="/querysite">
                <div class="demandimg1">
                  <img src="../assets/images/need_fast.svg" alt="快速查詢" />
                </div>
                <div class="button">
                  {{ $t('message.index_quick_query') }}
                  <div class="gobtn d-none d-xl-block">
                    {{ $t('message.index_go') }}
                  </div>
                </div>
              </router-link>
            </div>
            <div class="dbox2 col-xl-6 col-md-6">
              <router-link to="/feature">
                <div class="demandimg2">
                  <img src="../assets/images/need_in.svg" alt="進入官網" />
                </div>
                <div class="button">
                  {{ $t('message.index_enter_website') }}
                  <div class="gobtn2 d-none d-xl-block">
                    {{ $t('message.index_go') }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="browser" v-html="$t('message.index_browser_declare')"></div>

      <!--多國語系-->
      <LangBtns type="index"></LangBtns>
    </div>

    <div class="loadingop" :class="{ opcomplete: animate_completed }">
      <div class="logoop">
        <img src="../assets/images/logo.svg" alt="OWLocker智慧型寄物櫃,logo" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LangBtns from '@/components/LangBtns.vue';

export default {
  name: 'Home',
  components: {
    LangBtns,
  },
  data: function () {
    return {
      animate_completed: false,
    };
  },
  beforeDestroy: function () {
    var body = document.body;
    body.classList.add('bgcolor');
    body.classList.remove('bgblackcolor');
  },
  mounted: function () {
    //設定 body background
    var body = document.body;
    body.classList.remove('bgcolor');
    body.classList.add('bgblackcolor');
    //結束動畫進入網站
    var ref = this;
    setTimeout(function () {
      ref.animate_completed = true;
    }, 1800);
  },
};
</script>
